import { useMemo } from 'react';
import { useUserLevelPreference } from '@bingads-webui-campaign-react/common-hooks';
import { BudgetSuggestionTiers } from '@bingads-webui-campaign-react/budget-suggestion-v2';

export const preferenceNames = {
  WizardStep: 'PMaxLite.WizardStep',
  SelectedLanguage: 'PMaxLite.SelectedLanguage',
  SelectedCountry: 'PMaxLite.SelectedCountry',
  MarketPrefillEnabled: 'PMaxLite.MarketPrefillEnabled',
  BudgetSuggestionTier: 'PMaxLite.BudgetSuggestionTier',
  SelectedCurrency: 'PMaxLite.SelectedCurrency',
  WebsiteUrl: 'PMaxLite.WebsiteUrl',
  SmartPageUrl: 'PMaxLite.SmartPageUrl',
  SmartPageTermsAndConditions: 'PMaxLite.SmartPageTermsAndConditions',
  LanguageCountryPageTermsAndConditions: 'PMaxLite.LanguageCountryPageTermsAndConditions',
  TimezonePrefillEnabled: 'PMaxLite.TimezonePrefillEnabled',
  TempImageIdString: 'PMaxLite.TempImageIdString',
  PhoneNumberCountryCode: 'PMaxLite.PhoneNumberCountryCode',
  BusinessInfoPrefillEnabled: 'PMaxLite.BusinessInfoPrefillEnabled',
  BusinessInfoStepTAndC: 'PMaxLite.BusinessInfoStepTAndC',
};

export const getPreferenceDefaults = () => ({
  [preferenceNames.WizardStep]: {},
  [preferenceNames.SelectedLanguage]: 'English',
  [preferenceNames.SelectedCountry]: 'US',
  [preferenceNames.MarketPrefillEnabled]: true,
  [preferenceNames.BudgetSuggestionTier]: BudgetSuggestionTiers.Balanced,
  [preferenceNames.SelectedCurrency]: '',
  [preferenceNames.SmartPageTermsAndConditions]: {},
  [preferenceNames.LanguageCountryPageTermsAndConditions]: false,
  [preferenceNames.TimezonePrefillEnabled]: true,
  [preferenceNames.TempImageIdString]: '',
  [preferenceNames.PhoneNumberCountryCode]: '',
  [preferenceNames.BusinessInfoPrefillEnabled]: false,
  [preferenceNames.BusinessInfoStepTAndC]: false,
});

export function usePreference(preferenceName) {
  const preferenceDefaultValue = useMemo(() => {
    // load default from list of defaults
    const preferenceDefaults = getPreferenceDefaults();
    return preferenceDefaults[preferenceName];
  }, [preferenceName]);

  return useUserLevelPreference(preferenceName, preferenceDefaultValue);
}
